
 import { ArrowLeftOutlined } from '@ant-design/icons-vue'
import { defineComponent, ref } from 'vue'
import { mapActions, mapState } from 'vuex'
import DrawerHistory from '@/views/home/history/index.vue'
import { ListEnvelope } from '@/services/responses/ListEnvelopeResponse'
import router from '@/router'

export default defineComponent({
  name: 'HeaderContent',
  components: {
    DrawerHistory,
    ArrowLeftOutlined
  },
  data () {
    return {
      value: ref<string>(''),
      loading: ref<boolean>(false)
    }
  },
  watch: {
    async termSearch (newTermSearch, oldTermSearch) {
      if (newTermSearch !== '' || newTermSearch !== undefined) {
        this.value = newTermSearch
      } else {
        this.value = ''
      }
    }
  },
  computed: {
    ...mapState('sections', [
      'envelopes',
      'folderId',
      'currentStatus',
      'folderId',
      'filteredStatus',
      'termSearch'
    ]),
    envelops (): ListEnvelope[] {
      return this.envelopes !== null ? this.envelopes?.data : []
    }
  },
  methods: {
    ...mapActions('sections', [
      'fetchSearchEnvelope',
      'fetchEnvelopesByUser',
      'setOpenHistoric',
      'fetchHistoricEnvelops',
      'setTreeSelected',
      'fetchEnvelopesByVault',
      'setHomePage',
      'setCurrentStatus',
      'setTermSearch'
    ]),
    async openHistory () {
      let envelopeId: number[] | null = null
      if (this.folderId == null) {
        envelopeId = this.envelopes.data.map((x: any) => x.id)
      }
      await this.fetchHistoricEnvelops({
        folderId: this.folderId,
        envelopeId
      })
      this.setOpenHistoric(true)
    },
    async returnToVault () {
      this.setTreeSelected(['0'])
      this.loading = true
      if (this.currentStatus !== null) {
        await this.fetchEnvelopesByUser({
          page: 1,
          size: 9,
          status: this.currentStatus,
          filtered: null
        })
      } else {
        await this.fetchEnvelopesByVault({
          folderId: this.folderId,
          status: null,
          page: 1,
          size: 9
        })
      }
      this.loading = false
    },
    async onSearch (searchValue: string) {
      if (searchValue !== '') {
        this.setTreeSelected(['0'])
        this.loading = true
        await this.fetchSearchEnvelope({
          term: searchValue,
          status: this.currentStatus,
          folderId: this.currentStatus == null ? this.folderId : null,
          filtered: this.filteredStatus
        })
        this.loading = false
        this.setTermSearch(searchValue)
      } else {
        this.setTermSearch(undefined)
        this.setTreeSelected(['0'])
        this.loading = true
        if (this.currentStatus !== null) {
          await this.fetchEnvelopesByUser({
            page: 1,
            size: 9,
            status: this.currentStatus,
            filtered: null
          })
        } else {
          await this.fetchEnvelopesByVault({
            folderId: this.folderId,
            status: null,
            page: 1,
            size: 9
          })
        }
        this.loading = false
      }
    }
  }
})
